import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { makeStyles, getContrastRatio } from "@material-ui/core/styles";
import { useTenantImage } from "@ploy-ui/tenants";
import { ImageFit } from "@ploy-ui/core";
import Typography from "@material-ui/core/Typography";
import { HeaderIcon, SubmitButton, SubmitStatusMessage } from "./components";
import { Formik, Field, Form, connect } from "formik";
import { Grid } from "@material-ui/core";
import { Button } from "@ploy-ui/core";
import { Link } from "react-router-dom";
const useStyles = makeStyles(theme => ({
    link: {
        color: getContrastRatio(theme.palette.primary.main, theme.palette.common.white) < 2.5
            ? theme.palette.text.secondary
            : theme.palette.primary.main,
        textDecoration: "none"
    },
    forgotten: {
        marginTop: 10.5
    },
    shrink: {
        transform: "translate(0, -20px) !important"
    },
    img: {
        width: "100%",
        height: 120
    },
    headerText: { textAlign: "center", marginBottom: "50px" },
    usernamePasswordButton: {
        color: getContrastRatio(theme.palette.primary.main, theme.palette.common.white) < 2.5
            ? theme.palette.text.secondary
            : theme.palette.primary.main,
        textDecoration: "none"
    }
}), { name: "DployLoginFormBase" });
const AutoSubmit = connect(({ formik }) => {
    const { values, submitForm } = formik;
    const isMounting = useRef(true);
    useEffect(() => {
        if (!isMounting.current)
            submitForm();
        isMounting.current = false;
    }, [values, submitForm]);
    return null;
});
const FormBase = (props) => {
    const { submit, initValues, fieldConfig, submitButtonText, submitButtonClasses, SubmitButtonProps, hideHeaderText = false, icon = "lock", headerText, children, autoSubmit = false, toggleUsernamePassword: toggleUsernamePasswordConfig, forgottenPasswordLink } = props;
    const classes = useStyles();
    const [hideUsernamePasswordState, setHideUsernamePasswordState] = useState(toggleUsernamePasswordConfig);
    const hideUsernamePassword = hideUsernamePasswordState &&
        fieldConfig.findIndex(field => field.name === "username") > -1 &&
        fieldConfig.findIndex(field => field.name === "password") > -1;
    const onSubmit = useCallback(async (values, formik) => {
        try {
            formik.setStatus({});
            const { error } = await submit(values, formik);
            if (error) {
                const errors = {};
                const valueKeys = Object.keys(initValues);
                valueKeys.forEach((value, id) => {
                    errors[value] = id === valueKeys.length - 1 ? error : true;
                });
                formik.setErrors(errors);
            }
        }
        catch (error) {
            formik.setStatus({
                submit: {
                    status: "error",
                    message: (_jsx(FormattedMessage, { id: "dealer.login.login.error", description: "An error occurred", defaultMessage: "An error has occured" }))
                }
            });
        }
    }, [initValues, submit]);
    const loginLogo = useTenantImage("loginLogo");
    return (_jsxs("div", { children: [loginLogo ? (_jsxs(_Fragment, { children: [_jsx(ImageFit, { fit: "contain", src: loginLogo, alt: "logo", className: classes.img }), !hideHeaderText && (_jsx(Typography, { className: classes.headerText, variant: "h6", children: _jsx(FormattedMessage, { id: "external.login.header", description: "Header on forhandlerportal login", defaultMessage: "DEALER PORTAL" }) }))] })) : headerText ? (_jsx(HeaderIcon, { text: headerText })) : (_jsx(HeaderIcon, { icon: icon })), _jsx(Formik, { initialValues: initValues, onSubmit: onSubmit, children: _jsx(Form, { noValidate: true, children: _jsxs(Grid, { container: true, spacing: 2, children: [fieldConfig.map((field, idx) => {
                                const hidden = hideUsernamePassword &&
                                    (field.name === "username" || field.name === "password");
                                return (_jsx(Grid, { item: true, xs: 12, style: { display: hidden ? "none" : undefined }, children: _jsx(Field, { ...field }, `${idx}`) }, field.name));
                            }), autoSubmit && _jsx(AutoSubmit, {}), !hideUsernamePassword && (_jsx(Grid, { item: true, xs: 12, children: _jsx(SubmitButton, { classes: submitButtonClasses, size: "large", variant: "contained", color: "secondary", fullWidth: true, ...SubmitButtonProps, children: submitButtonText }) })), forgottenPasswordLink && !hideUsernamePassword && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { className: classes.forgotten, align: "center", children: _jsx(FormattedMessage, { id: "dealer.login.text.forgotten_password", description: "text for forgotten password. Params: link", defaultMessage: "Forgot your password? <a>Generate new password</a>", values: {
                                            a: (text) => forgottenPasswordLink.isRelative ? (_jsx(Link, { className: classes.link, to: forgottenPasswordLink.link, children: text })) : (_jsx("a", { className: classes.link, href: forgottenPasswordLink.link, children: text }))
                                        } }) }) })), hideUsernamePassword && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { onClick: (e) => setHideUsernamePasswordState(false), fullWidth: true, size: "large", variant: "text", color: "primary", children: _jsx(Typography, { align: "center", className: classes.usernamePasswordButton, children: _jsx(FormattedMessage, { id: "dealer.login.text.show_username_password", defaultMessage: "Login with username and password" }) }) }) })), _jsx(Grid, { item: true, xs: 12, children: _jsx(SubmitStatusMessage, {}) })] }) }) }), children] }));
};
export { FormBase };
//# sourceMappingURL=FormBase.js.map